import firebase from 'firebase'
import Vue from 'vue'


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD948wi-qCa5jjUrR9juuBYc_ddCkukuwY",
  authDomain: "dwhtest.com",
  projectId: "sftm-web",
  storageBucket: "sftm-web.appspot.com",
  messagingSenderId: "453368303647",
  appId: "1:453368303647:web:c4092344a03c40b5ad052a",
  measurementId: "G-999Y2L4ZEN",
};


let  googleAuthProvider = new firebase.auth.GoogleAuthProvider()
let  facebookAuthProvider = new firebase.auth.FacebookAuthProvider()
const app = firebase.initializeApp(firebaseConfig)
const anl = firebase.analytics(app);

Vue.prototype.$firebase = firebase
Vue.prototype.$googleAuthProvider = googleAuthProvider
Vue.prototype.$facebookAuthProvider = facebookAuthProvider


export default  firebase

